var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.9767 28.643C67.9659 23.9938 57.3262 31.8375 57.3262 36.0845C57.3295 48.7244 79.4022 62.8056 83.9767 62.2974C89.8582 61.6439 101.176 50.0209 102.602 45.3068C103.909 40.9843 98.1563 32.7606 83.9767 28.643Z",
    fill: "#FF7104"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4204 18.8052C23.7711 34.8156 31.6149 45.4551 35.8621 45.4551C48.5023 45.4518 62.5838 23.3796 62.0756 18.8052C61.4221 12.9238 49.7988 1.60608 45.0845 0.18074C40.762 -1.12616 32.538 4.6259 28.4204 18.8052Z",
    fill: "#FF7104"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4217 74.3677C35.4326 79.0169 46.0723 71.1733 46.0723 66.9262C46.069 54.2863 23.9963 40.2052 19.4217 40.7134C13.5402 41.3668 2.22219 52.9898 0.796822 57.704C-0.510105 62.0264 5.24209 70.2502 19.4217 74.3677Z",
    fill: "#FF7104"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1557 84.1968C78.8051 68.1863 70.9613 57.5469 66.7141 57.5469C54.0739 57.5502 39.9924 79.6223 40.5006 84.1968C41.1541 90.0781 52.7774 101.396 57.4916 102.821C61.8141 104.128 70.0381 98.3761 74.1557 84.1968Z",
    fill: "#FF7104"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading_icon.3748281b4a0c0a2bb4d4ac0f4d9c4cd8.svg";
export { ForwardRef as ReactComponent };